import React, { useEffect, useState } from "react";
import { YoutubeLogo, ArrowSquareOut } from "@phosphor-icons/react";
import { api } from "../lib/api";

export default function LatestVideos() {
  const [state, setState] = useState({ configured: false, videos: [], title: "Latest from the Shoow", loading: true });

  useEffect(() => {
    let mounted = true;
    api.get("/youtube/channel").then(({ data }) => {
      if (mounted) setState({ ...data, loading: false });
    }).catch(() => mounted && setState((s) => ({ ...s, loading: false })));
    return () => { mounted = false; };
  }, []);

  if (state.loading) return null;
  if (!state.configured || !state.videos || state.videos.length === 0) return null;

  return (
    <section className="relative max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-20" data-testid="latest-videos">
      <div className="flex items-end justify-between flex-wrap gap-3 mb-8">
        <div>
          <p className="text-[10px] sm:text-xs font-bold tracking-[0.4em] text-neon-cyan uppercase mb-2 inline-flex items-center gap-2">
            <YoutubeLogo size={14} weight="fill" /> {state.title || "Latest from the Shoow"}
          </p>
          <h2 className="text-3xl sm:text-4xl font-black tracking-tighter">Fresh from the channel.</h2>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {state.videos.map((v) => (
          <a
            key={v.id}
            href={v.url}
            target="_blank"
            rel="noopener noreferrer"
            className="group block rounded-md overflow-hidden border border-ink-600 bg-ink-800/40 hover:border-neon-cyan/50 transition-all duration-300"
            data-testid={`video-tile-${v.id}`}
          >
            <div className="relative aspect-video bg-ink-900 overflow-hidden">
              <img src={v.thumbnail} alt={v.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
              <span className="absolute bottom-2 right-2 px-2 py-1 rounded bg-ink-900/70 text-[10px] font-mono uppercase text-white inline-flex items-center gap-1">
                Watch <ArrowSquareOut size={10} />
              </span>
            </div>
            <p className="p-3 text-sm text-zinc-200 line-clamp-2 group-hover:text-white transition-colors">{v.title}</p>
          </a>
        ))}
      </div>
    </section>
  );
}
